import React from "react";
import { Users } from "react-feather";
import { Card, Row, Col } from "react-bootstrap";

const PopulationCard = () => {
  return (
    <Card>
      <Card.Body>
        <Row className="mb-3">
          <Col md={10}>
            <h1 className="display-3">360</h1>
            <h1>Teachers</h1>
          </Col>
          <Col>
            <div bg="" className="stat">
              <Users
                className="align-middle text-success"
                width={64}
                height={64}
              />
            </div>
          </Col>
        </Row>
        <Row>
          <h4 className="mb-3">Attendance</h4>
          <Col>
            Active
            <p className="display-5">20</p>
          </Col>
          <Col>
            Absent
            <p className="display-5">1</p>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default PopulationCard;
